module.exports = __webpack_public_path__ + "static/media/71hayS2aIfL._AC_SL1500_.257471a7.jpg";